import React, { useState, useEffect } from 'react';
import axios from 'axios';

import ProductCard from './ProductCard';
import VentaForm from './VentaForm';
import VentaDetalle from './VentaDetalle';

function ProductSection({title, productos, onAgregar }) {
    console.log("ProductSection");
    console.log(productos);
    //const [productos, setProductos] = useState([]);
    const [detalleVenta, setDetalleVenta] = useState([]);
    //const API_URL = 'http://localhost:8090/api';
    
    useEffect(() => {
     // const fetchProductos = async () => {
     // try {
     //   const res = await axios.get(`${API_URL}/productos/all`);
     //   setProductos(res.data);
      
      //} catch (error) {
      //  alert('Error al buscar productos');
     // }
   // };
    //fetchProductos();  

  }, []);
  {/*
  const handleAgregarAlCarrito = () => {
    if (!itemVenta.productoId || !itemVenta.cantidad) return;

    const producto = productos.find(p => p.id === parseInt(itemVenta.productoId));
    if (!producto) return;

    const cantidad = parseFloat(itemVenta.cantidad);
    if (cantidad <= 0 || cantidad > producto.stock) {
      alert("Cantidad inválida o insuficiente stock");
      return;
    }

    const subtotal = cantidad * parseFloat(producto.precio);
    const nuevoItem = {
      productoId: producto.id,
      nombre: producto.nombre,
      cantidad,
      precio: producto.precio,
      subtotal
    };

    setDetalleVenta([...detalleVenta, nuevoItem]);
    setItemVenta({ productoId: '', cantidad: '' });
  };
*/}

  return (

    <section className="product-section">
      <h3>{title}</h3>
      <div className="product-grid">
        {productos
          .filter(product => product.nombreCategoria?.toLowerCase() === title.toLowerCase())
          .sort((a, b) => a.id - b.id)
          .map(product => (
            
            <ProductCard
              key={product.id}
              idProduct={product.id}
              name={product.nombre}
              description={product.descripcion}
              price={product.precio}
              image={product.imagen ? product.imagen.replace(/\\/g, "/") : null}
              especificacion={product.especificacion}
              onAgregar={onAgregar}
            />
          ))}
      </div>
    </section>



    /*    <section className="product-section">
      <h3>{title}</h3>
      <div className="product-grid">
        {productos.map(product => 
        product.nombreCategoria === title ?(
          <ProductCard
            key={product.id}
            idProduct={product.id} 
            name={product.nombre}
            description={product.descripcion}
            price={`${product.precio}`}
            image={product.imagen}
            productos={productos}
            itemVenta={itemVenta}
            setItemVenta={setItemVenta}
            onAgregar={handleAgregarAlCarrito}
          />

        ):null)}

        
      </div>
      <VentaForm
          productos={productos}
          itemVenta={itemVenta}
          setItemVenta={setItemVenta}
          onAgregar={handleAgregarAlCarrito}
        />
      {detalleVenta.length > 0 && (
          <VentaDetalle
            detalleVenta={detalleVenta}
          />
        )}
    </section>
    */
    


  );
}

export default ProductSection;